import { FC, ReactNode } from 'react'
import LayoutHeader from '../header'

type Props = {
  children: ReactNode
}

const LayoutMain: FC<Props> = ({ children }) => {
  return (
    <main className="fixed inset-0 flex flex-col w-full p-2 pt-0 overflow-hidden text-balance">
      <LayoutHeader />
      <div className="flex flex-col flex-1 w-full min-h-0 pt-0 overflow-auto border bg-muted/50 rounded-xl">
        {children}
      </div>
    </main>
  )
}

export default LayoutMain
